import { render, staticRenderFns } from "./InviteAccept.vue?vue&type=template&id=6cf0e302&scoped=true"
import script from "./InviteAccept.vue?vue&type=script&lang=js"
export * from "./InviteAccept.vue?vue&type=script&lang=js"
import style0 from "./InviteAccept.vue?vue&type=style&index=0&id=6cf0e302&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf0e302",
  null
  
)

export default component.exports